export const KnownHeaders = {
  WorkspaceId: 'workspace',
} as const;
